import {Component} from '@angular/core';
import {ReferralInputComponent} from './referral-input.component';
import {VerificationState} from '../model/verification-state.model';
import {ReferralService} from '../service/referral.service';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {Keys, StorageService} from '../service/storage.service';
import {PartnerService} from '../service/partner.service';
import {UserService} from '../service/user.service';

const PARTNER_CODE_PATTERN = '([0-9A-Z]{3}[0-9]{3})+';
const IGNORE_CASE_FLAG = 'i';

@Component({
    selector: 'app-referral-partner-code',
    templateUrl: 'referral-input.component.html',
    styleUrls: ['referral-input.component.css'],
    providers: [ReferralService, ApiServiceService, PartnerService]
})

export class ReferralPartnerCodeComponent extends ReferralInputComponent {
    private userService: UserService;
    private partnerService: PartnerService;

    constructor(referralService: ReferralService, storageService: StorageService, analyticsTracker: AnalyticsTracker, userService: UserService, partnerService: PartnerService) {
        super(referralService, storageService, analyticsTracker);
        this.userService = userService;
        this.partnerService = partnerService;
    }

    async verifyReferralCode(): Promise<VerificationState> {
        if (this.isValidPartnerCode(this.referralCode)) {
            return await this.performPartnerVerification();
        } else {
            return await this.performReferralVerification();
        }

    }

    async performReferralVerification(): Promise<VerificationState> {
        return await super.verifyReferralCode();
    }

    protected isValidPartnerCode(referralCode: string) {
        const regExp = new RegExp(PARTNER_CODE_PATTERN, IGNORE_CASE_FLAG);
        return regExp.test(referralCode);
    }

    public isCodeVerified(): boolean {
        return super.isCodeVerified() || this.verificationState === VerificationState.PARTNER_VERIFIED;
    }

    private async performPartnerVerification() {
        try {
            this.referralCode = this.referralCode.toUpperCase();
            const partnerName = await this.partnerService.getPartnerNameByCode(this.referralCode);
            if (partnerName) {
                this.storageService.saveObjectToSession(Keys.REFERRER_CODE, this.referralCode);
                this.storageService.saveObjectToSession(Keys.REFERRER_USER_NAME, partnerName);
                this.storageService.saveObjectToSession(Keys.VERIFICATION_STATE, VerificationState.PARTNER_VERIFIED);
                this.verificationState = VerificationState.PARTNER_VERIFIED;
                return this.verificationState;
            } else {
                return this.performReferralVerification();
            }

        } catch (error) {
            this.verificationState = VerificationState.FAILED;
        }
    }

    protected async fetchAndRefreshCode(): Promise<void> {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const user = await this.userService.getProfileDetails(profileId);

        if (user.onboardedBy) {
            this.referralCode = user.onboardedBy;
            this.verificationState = VerificationState.PARTNER_VERIFIED;
        }
    }
}
